import isEqual from "lodash/isEqual";

import type {
    ISearchEngineDetails,
    IEditableSearchEngine,
} from "app/components/campaigns/searchEngine/SearchEnginesConsts";
import { EditMode, ESearchEngineDevice } from "app/components/campaigns/searchEngine/SearchEnginesConsts";
import { getSearchEngineAvailableLocations } from "app/components/campaigns/searchEngine/SearchEngineWizardSharedUtil";

import type { ISupportedLanguagesAndLocale } from "../campaigns-wizard/CampaignsWizardConsts";
import { ECampaignPagesError } from "../campaigns-wizard/CampaignsWizardConsts";

export const DEFAULT_SEARCH_ENGINE_FULL: ISearchEngineDetails = {
    company: {
        id: "Google",
        text: "Google",
        iconName: "google",
    },
    device: ESearchEngineDevice.COMBINED,
    id: "1",
    language: {
        id: "en-us",
        text: "English",
    },
    location: {
        id: 840,
        text: "United States",
        type: "Country",
    },
};

export const SEARCH_ENGINE_LIST_CONTAINING_UNCOMPLETED_SINGLE_ITEM: IEditableSearchEngine[] = [
    {
        editMode: EditMode.Draft,
        searchEngineDetails: {
            company: DEFAULT_SEARCH_ENGINE_FULL.company,
            device: ESearchEngineDevice.MOBILE,
            id: DEFAULT_SEARCH_ENGINE_FULL.id,
        },
    },
];

export const createSearchEngineItem = (id: string = Date.now().toString()): ISearchEngineDetails => ({
    ...DEFAULT_SEARCH_ENGINE_FULL,
    id,
});

export const createSearchEngineListItem = (id: string): IEditableSearchEngine[] => [
    {
        editMode: EditMode.Draft,
        searchEngineDetails: createSearchEngineItem(id),
    },
];
const formatSearchEngineListItems = (savedLists: ISearchEngineDetails[]): IEditableSearchEngine[] => {
    return savedLists.map((list) => {
        return {
            editMode: EditMode.Saved,
            searchEngineDetails: list,
        };
    });
};
export const getSearchEngineListItems = (savedLists: ISearchEngineDetails[] = []): IEditableSearchEngine[] => {
    return savedLists.length
        ? formatSearchEngineListItems(savedLists)
        : SEARCH_ENGINE_LIST_CONTAINING_UNCOMPLETED_SINGLE_ITEM;
};
export const getActiveSearchEnginesNumber = (editableSearchEngine: IEditableSearchEngine[]): number => {
    return editableSearchEngine?.filter((searchEngine) => {
        return searchEngine.editMode !== EditMode.Draft;
    }).length;
};

export const isEachSearchEngineBeingUsed = (
    wizardKeywordsState,
    wizardSearchEnginesState: ISearchEngineDetails[],
): ECampaignPagesError | null => {
    let checkIfAllSearchEnginesAreUsed = false;
    if (wizardKeywordsState?.length > 0) {
        const availableSearchEngines = getSearchEngineAvailableLocations(wizardSearchEnginesState);
        const allSearchEnginesIds = availableSearchEngines.map((engine) => engine.id);

        const usedSearchEnginesIds = wizardKeywordsState.reduce((acc, keyword) => {
            keyword.searchEngine.forEach((engine) => {
                if (engine.isSelected) {
                    acc.add(engine.id);
                }
            });
            return acc;
        }, new Set());

        const finalIds = [...usedSearchEnginesIds];
        checkIfAllSearchEnginesAreUsed = isEqual(finalIds.sort(), allSearchEnginesIds.sort());
    }

    return !checkIfAllSearchEnginesAreUsed ? ECampaignPagesError.SEARCH_ENGINES_NOT_ASSIGNED_ERROR : null;
};

export const getSearchEngineLangAsText = (languageList: ISupportedLanguagesAndLocale[], searchEngineLocale: string) => {
    // Find the first language that matches a locale
    const matchingLanguage = languageList?.find((language) => searchEngineLocale.includes(language.locale));

    // If a matching language is found, split the description and return the second part
    if (matchingLanguage) {
        const descriptionSplit = matchingLanguage.description.split(" - ");
        const [, countryLanguageText] = descriptionSplit;

        return countryLanguageText;
    }
};
